import React from 'react';
import './SiteCard.css';

function SiteCard({ site, isAdmin, dragMode, onDelete, onEdit, onDragStart, onDragOver, onDrop, onDragEnd, isDragging }) {
  
  const handleClick = () => {
    // Disable click redirection when in drag mode
    if (!dragMode) {
      // Store site data in localStorage to persist across page reloads
      const siteDataToStore = {
        name: site.name,
        url: site.url,
        icon: site.icon
      };
      console.log('SiteCard clicked, storing data:', siteDataToStore);
      localStorage.setItem('redirect_site_data', JSON.stringify(siteDataToStore));
      console.log('Data stored, verifying:', localStorage.getItem('redirect_site_data'));
      // Navigate to intermediate redirect page
      console.log('Navigating to /siteredirect');
      window.location.href = '/siteredirect';
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(site.siteId || site.id);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit(site);
  };

  return (
    <div 
      className={`site-card ${isDragging ? 'dragging' : ''} ${dragMode ? 'drag-mode-active' : ''}`}
      onClick={handleClick}
      draggable={isAdmin && dragMode}
      onDragStart={(e) => {
        if (isAdmin && dragMode) {
          e.stopPropagation();
          onDragStart(site);
        }
      }}
      onDragOver={(e) => {
        if (isAdmin && dragMode) {
          onDragOver(e);
        }
      }}
      onDrop={(e) => {
        if (isAdmin && dragMode) {
          e.stopPropagation();
          onDrop(site);
        }
      }}
      onDragEnd={() => {
        if (isAdmin && dragMode) {
          onDragEnd();
        }
      }}
      style={{ cursor: dragMode ? 'move' : 'pointer' }}
    >
      {isAdmin && (
        <div className="card-actions">
          {/* Hide edit button in drag mode */}
          {!dragMode && (
            <button className="edit-button" onClick={handleEdit} title="Edit site">
              ✎
            </button>
          )}
          {/* Delete button always visible */}
          <button className="delete-button" onClick={handleDelete} title="Remove site">
            ×
          </button>
        </div>
      )}
      <div className="site-icon">
        {site.icon === 'placeholder' ? (
          <div className="placeholder-icon">{site.name.charAt(0)}</div>
        ) : (
          <img src={site.icon} alt={site.name} />
        )}
      </div>
      <div className="site-name">{site.name}</div>
    </div>
  );
}

export default SiteCard;
